import useFetchHelpCenter from './fetch/useFetchHelpCenter';
import useIsMobile from './useIsMobile';

export default function useAutoOpenEnabled(): boolean {
  const isMobile = useIsMobile();
  const { data: helpCenterData } = useFetchHelpCenter();

  if (window?.location?.search?.toLowerCase()?.includes('engagehubopen=true')) {
    return true;
  }

  if (!helpCenterData?.options?.autoopen_chat) {
    return false;
  }

  if (!isMobile) {
    return true;
  }

  return !helpCenterData?.options.autoopen_mobile_disabled;
}
